// 权限api

import {baseRequest} from "./base";

/**
 * @desc 查询权限列表
 */
function getAccPermissionList(params) {
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/accPermission/'
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 新增权限
 */
function addPermission(params) {
  return baseRequest(`/api/pcWeb/accPermission/create`, 'post', params);
}

/**
 * @desc 删除权限
 */
function deletePermission(id) {
  return baseRequest(`/api/pcWeb/accPermission/delete/${id}`, 'get');
}

/**
 * @desc 修改权限
 */
function updatePermission(params) {
  return baseRequest(`/api/pcWeb/accPermission/update`, 'post', params);
}

/**
 * @desc 查询我的权限列表
 */
function listMyPerms(id, params) {
  return baseRequest(`/api/pcWeb/accPermission/listMyPerms`, 'get');
}


/**
 * @desc 查询全部权限
 */
function getAllPermissionList(id, params) {
  return baseRequest(`/api/pcWeb/accPermission/listAll`, 'get');
}


export default {
  getAccPermissionList: getAccPermissionList,
  addPermission: addPermission,
  deletePermission: deletePermission,
  updatePermission: updatePermission,
  listMyPerms:listMyPerms,
  getAllPermissionList:getAllPermissionList
}

